import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  settings: {},
  userData: null,
  doctorData: null,
};

const appSlice = createSlice({
  name: "appSlice",
  initialState,
  reducers: {
    updateSettings(state, action) {
      state.settings = action.payload;
    },
    updateUserData(state, action) {
      state.userData = action.payload;
    },
    updateDoctorData(state, action) {
      state.doctorData = action.payload;
    },
  },
});

// Export actions
export const { updateSettings, updateUserData, updateDoctorData } = appSlice.actions;

// Export the reducer
export default appSlice.reducer;
